import { gql } from "@apollo/client";

export const CERTIFICATION_EMAIL_REQUEST_MUTATION = gql`
mutation requestCertificationByEmail($certificationId: String!) {
  requestCertificationByEmail(input: { certificationId: $certificationId }) {
    ... on RequestCertificationByEmailPayload {
      certificationEmailRequest {
        status
        errorCode
        displayMessage, 
        detail
      }
    }
  }
}
`;